import React from 'react';

type StatTone = 'default' | 'ok' | 'warn' | 'danger' | 'info' | 'teal' | 'coral';

const valueColors: Record<StatTone, string> = {
  default: 'text-ink-800',
  ok:      'text-ok-500',
  warn:    'text-warn-500',
  danger:  'text-danger-500',
  info:    'text-info-500',
  teal:    'text-teal-600',
  coral:   'text-coral-500',
};

interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  tone?: StatTone;
  badge?: React.ReactNode;
  icon?: React.ReactNode;
  trend?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, sub, tone = 'default', badge, icon, trend }) => (
  <div className="bg-card rounded-12 border border-ink-200 p-4 shadow-xs flex flex-col gap-1 min-w-0">
    <div className="flex items-center justify-between mb-1">
      <span className="text-[12px] font-medium text-ink-600 leading-tight">{label}</span>
      {icon && (
        <span className="w-6 h-6 rounded-6 bg-ink-100 flex items-center justify-center text-ink-600">
          {icon}
        </span>
      )}
    </div>
    <div className={`text-[28px] font-semibold leading-none tracking-tight tabular-nums ${valueColors[tone]}`}>
      {value}
    </div>
    {sub && <div className="text-[12px] text-ink-500 mt-0.5">{sub}</div>}
    {badge && <div className="mt-1">{badge}</div>}
    {trend && <div className="text-[11px] text-ink-500 mt-1">{trend}</div>}
  </div>
);

export default StatCard;
